export default __webpack_public_path__ + "static/media/6.e11e5179.png";